import {range} from 'external/lodash'
import moment from 'external/moment'
import {useRef} from 'external/react'
import {styled, Box} from 'external/material'
import Header, {headerStyles} from './Header'
import WeekGroup from './Group'

import useDimensions from 'hooks/dimensions'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'
import useStudent from 'hooks/student'

const groupWidth = 200
const groupStyle = {with: groupWidth, maxWidth: groupWidth, minWidth: groupWidth}

const StyledWeek = styled(Box)(weekStyles)
const StyledGroupHeader = styled('div')(headerStyles)

export default function WeekView () {

  const ref = useRef()
  const {translate} = useTranslations()
  const {query} = useSession()
  const context = useStudent()
  const start = context.date().startOf('week')
  const {groups} = context
  const {width} = useDimensions(ref)
  const dayWidth = Math.round((width - groupWidth - 12) / 7)
  const daySize = {
    width: dayWidth, maxWidth: dayWidth, minWidth: dayWidth
  }

  const weeks = groups
    .filter(group => !query.clique || query.clique == group.id)
    .map(group => ({context, group, start, daySize}))
    .map((props,i) => (<WeekGroup key={i} {...props}/>))

  const headers = range(7)
    .map(d => ({date: moment(start).add(d, 'days'), daySize}))
    .map((props,i) => (<Header key={i} {...props}/>))

  return (<StyledWeek className="week-view" ref={ref}>
        <div className="headers">
          <StyledGroupHeader className="header groups" style={groupStyle}>
            {translate('groups_label')}
          </StyledGroupHeader>
          {headers}
        </div>
        <div className="weeks">
          {weeks}
        </div>
  </StyledWeek>)
}

function weekStyles () {
  return {
    "&.week-view": {
        overflow: 'hidden',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        color: '#69738e',
        backgroundColor: '#fff',
        "& .headers": {
          display: 'flex',
          flexShrink: 0,
          fontSize: '10pt',
          color: '#69738e',
          borderTop: 'solid 1px #e1eaee',
          borderBottom: 'solid 1px #e1eaee'
        },
        "& .weeks": {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'auto'
        }
    }
  }
}
